<div class="nha-sa-title">
  <div class="nha-pre-header" id="submittedSuccessful">{{appContent.resourceStrings["nha.sa.applicationsubmitted"]}}</div>
  <h1 class="nha-primary-heading">{{appContent.resourceStrings["nha.sa.thankyouforapplying"]}}</h1>
</div>
<div class="nha-row">
  <div class="nha-gr-12">
    <h2>{{appContent.resourceStrings["nha.sa.whatsnext"]}}</h2>
    <ul>
      <li>{{appContent.resourceStrings["nha.sa.whatsnextanswerone"]}}</li>
      <li>{{appContent.resourceStrings["nha.sa.whatsnextanswertwo"]}}</li>
      <li [innerHTML]="appContent.resourceStrings['nha.sa.whattoexpectsubmitted']"></li>
      <li>
        {{appContent.resourceStrings["nha.sa.howheardbullet"]}}
        <a [href]="howHeardLinkUrl()" target="_blank">{{appContent.resourceStrings["nha.sa.howheardlinktext"]}}</a>.
      </li>
    </ul>
    <hr>
  </div>
</div>
<div class="nha-row">
  <div class="nha-gr-12">
    <h3>{{appContent.resourceStrings["nha.sa.confirmationquestions"]}}</h3>
    <p>{{appContent.resourceStrings["nha.sa.confirmationquestionhelptext"]}}</p>
  </div>
  <div *ngFor="let school of appliedSchools; let s=index" class="nha-gr-12 nha-gr-6@sm">
    <h3>{{school.schoolName}}</h3>
    <div class="nha-green-bar-left-sm"></div>
    <ul class="nha-contact-info">
      <li class="nha-contact-info-email1">
        <a *ngIf="school.email" href="mailto:{{school.email}}">{{school.email}}</a>
        <a *ngIf="!school.email" href="mailto:info&#64;nhaschools.com">info&#64;nhaschools.com</a>
      </li>
      <li class="nha-contact-info-phone">
        <a *ngIf="school.phone" href="tel:{{school.phone}}">{{school.phone}}</a>
        <a *ngIf="!school.phone" href="tel:877-223-6402">877-223-6402</a>
      </li>
    </ul>
  </div>
  <div *ngFor="let school of nearbySchoolsApplying; let s=index" class="nha-gr-12 nha-gr-6@sm">
    <h3>{{school.schoolName}}</h3>
    <div class="nha-green-bar-left-sm"></div>
    <ul class="nha-contact-info">
      <li class="nha-contact-info-email1">
        <a *ngIf="school.content.email" href="mailto:{{school.content.email}}">{{school.content.email}}</a>
        <a *ngIf="!school.content.email" href="mailto:info&#64;nhaschools.com">info&#64;nhaschools.com</a>
      </li>
      <li class="nha-contact-info-phone">
        <a *ngIf="school.content.phone" href="tel:{{school.content.phone}}">{{school.content.phone}}</a>
        <a *ngIf="!school.content.phone" href="tel:877-223-6402">877-223-6402</a>
      </li>
    </ul>
  </div>
  <hr>
</div>
<div class="nha-row">
  <div id="nha-sa-review-app" class="nha-gr-12">
    <a (click)="toggleReviewForm()">
      {{appContent.resourceStrings["nha.sa.reviewapplication"]}}&nbsp;
      <span *ngIf="!showReviewForm" class="fa fa-chevron-down"></span>
      <span *ngIf="showReviewForm" class="fa fa-chevron-up"></span>
    </a>
  </div>
</div>
<div *ngIf="appData && appContent && showReviewForm" class="nha-sa-submitted-data">
  <div class="nha-sa-section-header">{{appContent.resourceStrings["nha.sa.schoolyearheader"]}}</div>
  <div class="nha-row">
    <div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md">
      <label>{{appContent.resourceStrings["nha.sa.schoolyearsubtext"]}}</label>
      <span>{{appData.academicYearId}}-{{appData.academicYearId + 1}}</span>
      <span *ngIf="appContent.currentAcademicYear == appData.academicYearId">
        ({{appContent.resourceStrings["nha.sa.currentschoolyear"]}})</span>
      <span *ngIf="appContent.nextAcademicYear == appData.academicYearId">
        ({{appContent.resourceStrings["nha.sa.nextschoolyear"]}})</span>
    </div>
  </div>
  <div *ngFor="let guardian of appData.guardians; let g=index">
    <div class="nha-sa-section-header">{{guardian.firstName}} {{guardian.lastName}}</div>
    <div class="nha-row">
      <div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md">
        <label>{{appContent.resourceStrings["nha.sa.guardianfirstname"]}}</label>
        <span>{{guardian.firstName}}</span>
      </div>
      <div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md nha-suffix-2@md">
        <label>{{appContent.resourceStrings["nha.sa.guardianlastname"]}}</label>
        <span>{{guardian.lastName}}</span>
      </div>
    </div>
    <div class="nha-row">
      <div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md nha-suffix-7@md">
        <label>{{appContent.resourceStrings["nha.sa.guardianemail"]}}</label>
        <span *ngIf="guardian.email; else noEmail">{{guardian.email}}</span>
        <ng-template #noEmail><span>None</span></ng-template>
      </div>
    </div>
    <div class="nha-row">
      <div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md">
        <label>{{appContent.resourceStrings["nha.sa.guardianprimaryphonenumber"]}}</label>
        <span>{{guardian.primaryPhone}}</span>
      </div>
      <div *ngIf="guardian.secondaryPhone" class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md nha-suffix-2@md">
        <label>{{appContent.resourceStrings["nha.sa.secondaryphonenumber"]}}</label>
        <span>{{guardian.secondaryPhone}}</span>
      </div>
    </div>
    <hr>
    <div class="nha-row">
      <div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md">
        <label>{{appContent.resourceStrings["nha.sa.guardianstreetaddress"]}}</label>
        <span>{{guardian.household.address}}</span>
      </div>
      <div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md nha-suffix-2@md">
        <label>{{appContent.resourceStrings["nha.sa.guardiancity"]}}</label>
        <span>{{guardian.household.city}}</span>
      </div>
    </div>
    <div class="nha-row">
      <div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md">
        <label>{{appContent.resourceStrings["nha.sa.guardianstate"]}}</label>
        <span>{{guardian.household.stateCode | dataFilter:[appContent.states, 'code', 'name']}}</span>
      </div>
      <div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md nha-suffix-2@md">
        <label>{{appContent.resourceStrings["nha.sa.guardianzipcode"]}}</label>
        <span>{{guardian.household.zipCode}}</span>
      </div>
    </div>
  </div>
  <div *ngFor="let child of appData.children; let c=index">
    <div class="nha-sa-section-header">{{child.firstName}} {{child.lastName}}</div>
    <div class="nha-row">
      <div *ngFor="let relationship of child.guardianRelationships; let r=index" class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md">
        <label>
          {{relationship.internalGuardianId | dataFilter:[appData.guardians, 'internalGuardianId'] | fullName:null |
          possessive}} Relationship to Child
        </label>
        <span>{{relationship.relationshipTypeId | number | dataFilter:[appContent.relationshipTypes, 'relationshipTypeID',
          'relationshipTypeName']}}</span>
      </div>
    </div>
    <div class="nha-row">
      <div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md">
        <label>{{appContent.resourceStrings["nha.sa.childsfirstname"]}}</label>
        <span>{{child.firstName}}</span>
      </div>
      <div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md nha-suffix-2@md">
        <label>{{appContent.resourceStrings["nha.sa.childsmiddlename"]}}</label>
        <span>{{child.middleName}}</span>
      </div>
    </div>
    <div class="nha-row">
      <div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md">
        <label>{{appContent.resourceStrings["nha.sa.childslastname"]}}</label>
        <span>{{child.lastName}}</span>
      </div>
      <div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md nha-suffix-2@md">
        <label>{{appContent.resourceStrings["nha.sa.childssuffix"]}}</label>
        <span>{{child.suffixId | dataFilter:[appContent.nameSuffixes, 'nameSuffixID', 'suffix']}}</span>
      </div>
    </div>
    <div class="nha-row">
      <div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md">
        <label>{{appContent.resourceStrings["nha.sa.childsbirthdate"]}}</label>
        <span>{{child.birthDate}}</span>
      </div>
    </div>
    <div *ngIf="child.isKindergartenWaiverApproved" class="nha-row">
      <div class="nha-form-group nha-gr-12">
        <label>
          <span class="fa fa-check-square" aria-hidden="true"></span>&nbsp;{{appContent.resourceStrings["nha.sa.kindergartenwaiver"]}}
        </label>
      </div>
    </div>
    <div *ngIf="child.genderId" class="nha-row">
      <div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md nha-suffix-2@md">
        <label>{{appContent.resourceStrings["nha.sa.childsgender"]}}</label>
        <span *ngIf="child.genderId == 1">{{appContent.resourceStrings["nha.sa.childsgendermale"]}}</span>
        <span *ngIf="child.genderId == 2">{{appContent.resourceStrings["nha.sa.childsgenderfemale"]}}</span>
      </div>
    </div>
    <div *ngIf="child.preferredLanguage" class="nha-row">
      <div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md nha-suffix-2@md">
        <label>{{appContent.resourceStrings["nha.sa.childspreferredlanguage"]}}</label>
        <span>{{child.preferredLanguage}}</span>
      </div>
    </div>
    <hr>
    <div class="nha-row">
      <div *ngFor="let household of child.householdResidencies; let h=index" class="nha-form-group nha-gr-12">
        <label>
          {{appContent.resourceStrings["nha.sa.childsresidencequestionreview"]}}
          {{household.internalHouseholdId | dataFilter:[uniqueHouseholds, 'internalHouseholdId', 'address']}}?
        </label>
        <span>{{household.residencyTypeId | dataFilter:[appContent.residencyTypes, 'residencyTypeID',
          'residencyTypeName']}}</span>
      </div>
    </div>
    <hr>
    <div class="nha-row" *ngIf="appContent.schoolID === 514">
      <div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md">
        <label>{{appContent.resourceStrings["nha.sa.isfreereducedlunchmigranthomelessprimarylanguagenotenglishdisabilityiep"]}}</label>
        <span *ngIf="child.isFreeReducedLunchMigrantHomelessPrimaryLanguageNotEnglishDisabilityIEP == true">{{appContent.resourceStrings["nha.sa.yes"]}}</span>
        <span *ngIf="child.isFreeReducedLunchMigrantHomelessPrimaryLanguageNotEnglishDisabilityIEP == false">No</span>
      </div>
    </div>
    <div class="nha-row">
      <div *ngFor="let school of child.applicationForSchools; let s=index" class="nha-form-group nha-gr-12">
        <div *ngIf="s == 0">
          <label>
            {{appContent.schoolName}}:<br>
            {{appContent.resourceStrings["nha.sa.gradeentering"]}} {{appData.academicYearId}}-{{appData.academicYearId
            + 1}}
          </label>
          <span *ngIf="appData.academicYearId == appContent.currentAcademicYear">
            {{school.gradeLevelId | dataFilter:[appContent.currentGradeLevels, 'gradeLevelID', 'description']}}
          </span>
          <span *ngIf="appData.academicYearId == appContent.nextAcademicYear">
            {{school.gradeLevelId | dataFilter:[appContent.nextGradeLevels, 'gradeLevelID', 'description']}}
          </span>
        </div>
        <div *ngIf="s > 0">
          <label>
            {{school.schoolId | dataFilter:[nearbySchoolsApplying, 'schoolID', 'schoolName']}}:<br>
            {{appContent.resourceStrings["nha.sa.gradeentering"]}} {{appData.academicYearId}}-{{appData.academicYearId
            + 1}}
          </label>
          <span *ngIf="appData.academicYearId == appContent.currentAcademicYear">
            {{school.gradeLevelId |
            dataFilter:[(school.schoolId |
            dataFilter:[nearbySchoolsApplying, 'schoolID', 'content']).currentGradeLevels, 'gradeLevelID',
            'description']}}
          </span>
          <span *ngIf="appData.academicYearId == appContent.nextAcademicYear">
            {{school.gradeLevelId |
            dataFilter:[(school.schoolId |
            dataFilter:[nearbySchoolsApplying, 'schoolID', 'content']).nextGradeLevels, 'gradeLevelID',
            'description']}}
          </span>
        </div>
      </div>
    </div>
    <div *ngIf="child.receivedSpecialEducationServices !== null" class="nha-row">
      <div class="nha-form-group nha-gr-12">
        <label>
          {{appContent.resourceStrings["nha.sa.childreceivedspecialed"]}}
        </label>
        <span *ngIf="child.receivedSpecialEducationServices">{{appContent.resourceStrings["nha.sa.yes"]}}</span>
        <span *ngIf="!child.receivedSpecialEducationServices">No</span>
      </div>
    </div>
    <div *ngIf="child.previousSchool" class="nha-row">
      <div class="nha-form-group nha-gr-12">
        <label>
          {{appContent.resourceStrings["nha.sa.previousschool"]}}
        </label>
        <span>{{child.previousSchool}}</span>
      </div>
    </div>
  </div>
  <div>
    <div class="nha-sa-section-header">{{appContent.resourceStrings["nha.sa.termsconditionsheader"]}}</div>
    <div class="nha-row">
      <div class="nha-form-group nha-gr-12 nha-gr-6@sm nha-gr-5@md">
        <label>{{appContent.resourceStrings["nha.sa.termsconditionsacknowledgetext"]}}</label>
        <span>
          {{appData.completedByInternalGuardianId | dataFilter:[appData.guardians, 'internalGuardianId'] | fullName:null}}
        </span>
      </div>
      <div class="nha-gr-12">
        <span class="nha-sa-terms-sublabel">
          {{appContent.resourceStrings["nha.sa.termsconditionsacknowledgetextparttwo"]}}
          <a href="{{termsConditionsUrl}}" class="nha-sa-terms-link-submitted">{{appContent.resourceStrings["nha.sa.termsconditionslink"]}}</a>.
        </span>
      </div>
      <div class="nha-gr-12 nha-form-group">
        <label for="termsConditionsCheck">
          <span class="fa fa-check-square" aria-hidden="true"></span>&nbsp;{{appContent.resourceStrings["nha.sa.termsconditionsagree"]}}
        </label>
      </div>
    </div>
  </div>
</div>
<div class="nha-row">
  <hr>
  <div class="nha-gr-12">
    <p [innerHTML]="appContent.resourceStrings['nha.sa.confirmationconsent']"></p>
  </div>
  <button type="button" class="nha-btn nha-btn-primary nha-btn-homepage" (click)="goToHomepage()">{{appContent.resourceStrings["nha.sa.backtohomepagebutton"]}}</button>
</div>
